// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1B2Jd","vLegacy":"SelectSecondary_vLegacy__21EfJ","error":"SelectSecondary_error__2VlQK","disabled":"SelectSecondary_disabled__1kuuY"};